import * as React from "react";
import * as ReactDOM from "react-dom";
import { RetrieveDocuments } from "./ProstewardAPI";
import { populateSearchCriteria } from "./SearchCriteria";
import Erorrnotification from "../components/ErrorNotifications/Notifications";

export const SearchResultLoader = (props) => {
  let pending = React.useRef("");
  const lastSuccess = React.useRef("");
  const [errors, setErrors] = React.useState({ isError: false, errormsg: "" });
  const encodeRequest = () => {
    let data = {
      dataState: props.dataState,
      searchCriteria: props.searchCriteria,
    };
    return JSON.stringify(data);
  };
  const clearErrors = () => {
    setErrors({ isError: false, errormsg: "" });
  };
  const requestDataIfNeeded = () => {
    if (pending.current || encodeRequest() == lastSuccess.current) {
      return;
    }

    pending.current = encodeRequest();
    const data = populateSearchCriteria(props);

    RetrieveDocuments(data)
      .then((res) => {
        lastSuccess.current = pending.current;
        pending.current = "";

        if (encodeRequest() === lastSuccess.current) {
          props.onDataReceived.call(undefined, {
            data: res.data.Results,
            total: res.data.TotalResult,
          });
        } else {
          requestDataIfNeeded();
        }
      })
      .catch((err) => {
        console.log("error retrieving search results " + err);
        setErrors({ isError: true, errormsg: err });
      });
  };
  requestDataIfNeeded();
  if (errors.isError) {
    return (
      <Erorrnotification
        errors={errors.errormsg.message + ". Please refresh the page"}
        onErrorCompletion={clearErrors}
        type="error"
        closeButton={false}
      />
    );
  } else return pending.current ? <LoadingPanel /> : null;
};

const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};
